import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useWindowDimensions } from "src/hooks/useWindowdimension";

const PageDropdownMenu = ({ data, closeMenu }) => {
  const [animatePhase1, setAnimatePhase1] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  useEffect(() => {
    const timer1 = setTimeout(() => setAnimatePhase1(true), 50);
    return () => clearTimeout(timer1);
  }, []);

  useEffect(() => {
    setIsMobile(width <= 768);
  }, [width]);

  const handlePageClick = (page) => {
    const target = page.link || (page.slug ? `/page/${page.slug}` : null);
    if (target) {
      navigate(target);
      closeMenu();
    }
  };

  // Mobile layout - simple text list like Shop menu
  if (isMobile) {
    return (
      <div className="space-y-1">
        {data &&
          data.map((item, index) => (
            <div
              key={index}
              className={`transform transition-all duration-300 ease-out cursor-pointer
                ${animatePhase1 
                  ? 'opacity-100 translate-x-0' 
                  : 'opacity-0 -translate-x-4'
                }
              `}
              style={{
                transitionDelay: `${index * 30}ms`
              }}
              onClick={() => handlePageClick(item.pageData)}
            >
              <div
                className="cursor-pointer hover:underline text-[14px] font-normal font-outfitRegular py-1"
                style={{ color: 'var(--navbar-link-color)' }}
                onMouseEnter={(e) => e.currentTarget.style.color = 'var(--navbar-link-hover-color)'}
                onMouseLeave={(e) => e.currentTarget.style.color = 'var(--navbar-link-color)'}
              >
                {item.heading}
              </div>
            </div>
          ))}
      </div>
    );
  }

  // Desktop layout - card format
  return (
    <div className="bg-white shadow-xl rounded-lg mt-0 lg:mt-6 border border-gray-200 overflow-hidden min-w-[180px] max-w-[210px]">
      
      {/* Clean vertical list without dividers */}
      <div className="py-2">
        {data &&
          data.map((item, index) => (
            <div
              key={index}
              className={`transform transition-all duration-300 ease-out cursor-pointer
                ${animatePhase1 
                  ? 'opacity-100 translate-x-0' 
                  : 'opacity-0 -translate-x-4'
                }
              `}
              style={{
                transitionDelay: `${index * 30}ms`
              }}
              onClick={() => handlePageClick(item.pageData)}
            >
              <div className="group relative bg-white hover:bg-blue-50 transition-all duration-200 px-3 py-2.5 flex items-center justify-between">
                
                {/* Left side: Icon + Title */}
                <div className="flex items-center space-x-2.5">
                  {/* Title */}
                  <h4 className="text-gray-700 group-hover:text-gray-900 text-sm font-medium transition-colors duration-200">
                    {item.heading}
                  </h4>
                </div>

                {/* Right arrow */}
                <div className="text-gray-400 group-hover:text-black transition-all duration-200 opacity-60 group-hover:opacity-100 transform group-hover:translate-x-1">
                  <ChevronRight className="w-4 h-4" />
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PageDropdownMenu;
